import { ClaimItemDTO, ClaimProposalDTO } from '@reposit/api-client';
import React from 'react';
import RepositCard from '../Reposit/RepositCard';
import { Table, Tbody, Td, Thead, Tr } from '../Table';
import IndividualItem from './IndividualItem';

interface ClaimItemsProps {
  title: string;
  showDeletedAt?: boolean;
  items: ClaimItemDTO[];
  proposals: ClaimProposalDTO[];
  onEditClaimItem?: (claimItemId: string, currentAmount: number, title: string, itemType: string) => void;
  isUpdatingAmount?: boolean;
  isEditDisabled?: boolean;
  editDisabledReason?: string;
}

const ClaimItems: React.FC<ClaimItemsProps> = ({
  title,
  items,
  showDeletedAt = false,
  proposals,
  onEditClaimItem,
  isUpdatingAmount = false,
  isEditDisabled = false,
  editDisabledReason,
}) => {
  const showActions = !!onEditClaimItem && !showDeletedAt;
  return (
    <RepositCard flush title={title} tooltip="lorem">
      <Table>
        <Thead>
          <Tr>
            <Td>ID</Td>
            <Td>Title</Td>
            <Td>Description</Td>
            <Td>Type</Td>
            <Td>Amount</Td>
            <Td>Evidence</Td>
            {showActions && <Td>Actions</Td>}
            {showDeletedAt && <Td>Deleted At</Td>}
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item) => (
            <IndividualItem
              item={item}
              showDeletedAt={showDeletedAt}
              proposals={proposals}
              onEditClaimItem={onEditClaimItem}
              isUpdating={isUpdatingAmount}
              isEditDisabled={isEditDisabled}
              editDisabledReason={editDisabledReason}
              key={item.id}
            />
          ))}
        </Tbody>
      </Table>
    </RepositCard>
  );
};

export default ClaimItems;
